import TrumpTrackerScrollerPanel from './trump-tracker-scroller-panel';
import { useState } from 'react';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import { MarketSignalAlarmConfig } from '@/modules/market-signals/model/market-signals/market-signal-alarm-config';
import { useTimer } from '@/shared/hooks/export';

export default function TrumpTrackerScroller() {
  const [config, setConfig] = useState<MarketSignalAlarmConfig>();
  // const [showConfigModal, setShowConfigModal] = useState<boolean>(false);
  const configId = '6960c5191cf318fed5f73854';

  useTimer(
    1_200_000,
    () => {
      marketSignalApi
        .getAlarmConfigs(0)
        .then(v => setConfig(v.content.find(f => f._id === configId)));
    },
    true,
    'tt-config-reload',
  );

  return (
    <div className="h-100 d-flex flex-column">
      <div className="mb-1">
        <div className="h4 text-truncate text-center">{config?.condition || '?'}</div>
        {/* <Button size='sm' variant='link' className='text-body p-0' onClick={() => setShowConfigModal(true)}>
          <FontAwesomeIcon icon={faGear} />
        </Button> */}
      </div>

      {/* {showConfigModal && <MarketSignalAlarmEditModal alarm={config} onClose={() => setShowConfigModal(false)} />} */}

      <div className="flex-grow-1 overflow-hidden">
        <TrumpTrackerScrollerPanel conditionId={configId} />
      </div>
    </div>
  );
}
